const question6 = {
    'question': 'Czy seksuolog może przepisać leki?',
    'answer': 'Lekarz seksuolog, który ukończył studia medyczne i specjalizację w zakresie seksuologii, może przepisywać leki. Psycholog seksuolog, który ukończył studia psychologiczne i specjalizację w zakresie seksuologii, nie może przepisywać leków.',
}

export default question6;